/* CustomFind — Timepiece Trading storefront build.
 * Collection pages, the search results page and instant search, served by the
 * CustomFind engine (Typesense). Replaces Sobooster USF one-to-one: same
 * facets, same sort options, same merchandising rules, same layout.
 */
(function () {
  'use strict';

  var C = window.CF_TPT;
  if (!C || !C.apiKey) return;

  var MOBILE = 749;
  var SEARCH_FIELDS = 'title,sku,vendor,tags,product_type,' + C.facets.map(function (f) { return f.field; }).join(',');
  var SEARCH_WEIGHTS = '8,8,4,2,2,' + C.facets.map(function () { return '3'; }).join(',');

  // ─── Utilities ─────────────────────────────────────────────────────────────

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function text(tag, cls, str) {
    var n = el(tag, cls);
    n.textContent = str;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(str) {
    var args = Array.prototype.slice.call(arguments, 1);
    return str.replace(/\{(\d+)\}/g, function (_, i) { return args[i] != null ? args[i] : ''; });
  }
  function debounce(fn, ms) {
    var t;
    return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); };
  }
  function isMobile() { return window.innerWidth <= MOBILE; }

  // Shopify money format ("${{amount}}", "${{amount_no_decimals}}", ...).
  function money(value) {
    var n = Number(value) || 0;
    var f = C.moneyFormat || '${{amount}}';
    // Whole amounts drop their ".00" — "$3,230", "$0" — as the previous app did;
    // cents only appear when there are cents ("$5,639.25").
    function sep(num, thousands, decimal, decimals) {
      var fixed = num.toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      if (parts.length > 1 && /^0+$/.test(parts[1])) return parts[0];
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return sep(n, ',', '.', 0);
        case 'amount_with_comma_separator': return sep(n, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return sep(n, '.', ',', 0);
        case 'amount_with_apostrophe_separator': return sep(n, "'", '.', 2);
        case 'amount_no_decimals_with_space_separator': return sep(n, ' ', '.', 0);
        case 'amount_with_space_separator': return sep(n, ' ', ',', 2);
        default: return sep(n, ',', '.', 2);
      }
    }).replace(/<[^>]+>/g, '');
  }

  // A product priced at 0 is a "call for price" item on this store.
  function priceText(value) {
    return Number(value) > 0 ? money(value) : (C.strings.priceOnRequest || 'Price on request');
  }

  function img(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function productUrl(handle) {
    var root = C.rootUrl || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + handle;
  }
  function quote(v) { return '`' + String(v).replace(/`/g, '') + '`'; }

  function store(key, value) {
    try {
      if (value === undefined) { var raw = localStorage.getItem(key); return raw ? JSON.parse(raw) : null; }
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { return null; }
  }

  // ─── Engine ────────────────────────────────────────────────────────────────

  var licence = { ok: true };

  function engine(path, opts) {
    opts = opts || {};
    return fetch(C.host + path, {
      method: opts.method || 'GET',
      headers: Object.assign({ 'X-TYPESENSE-API-KEY': C.apiKey }, opts.body ? { 'Content-Type': 'application/json' } : {}),
      body: opts.body ? JSON.stringify(opts.body) : undefined,
    }).then(function (res) {
      if (res.status === 401 || res.status === 403) { licence.ok = false; throw new Error('licence'); }
      return res.json().then(function (body) {
        if (!res.ok) throw new Error(body && body.message || ('HTTP ' + res.status));
        return body;
      });
    });
  }

  function multiSearch(searches) {
    return engine('/multi_search', { method: 'POST', body: { searches: searches } }).then(function (body) {
      var results = body.results || [];
      results.forEach(function (r) { if (r && r.code === 401) { licence.ok = false; throw new Error('licence'); } });
      return results;
    });
  }

  // Give the page back to the theme: the same products, Dawn's own grid.
  function fallback() {
    var u = new URL(window.location.href);
    u.searchParams.set('view', 'no-usf');
    window.location.replace(u.toString());
  }

  // ─── Merchandising rules ───────────────────────────────────────────────────

  // Collection ordering, as tiers. First matching expression wins, so the most
  // specific comes first. Mirrors the Sobooster rules: boost tag "available",
  // bury out of stock, bury price 0 — and what we measured on the live store.
  function tierSort() {
    var r = C.rules || {};
    var boost = (r.boostTags || []).length ? '(tags:=[' + r.boostTags.map(quote).join(',') + '])' : null;
    var inStock = r.buryOutOfStock ? 'inventory_total:>0' : null;
    var priced = r.buryUnpriced ? 'price:>0' : null;
    function all() {
      var parts = Array.prototype.slice.call(arguments).filter(Boolean);
      return parts.length ? '(' + parts.join(' && ') + ')' : null;
    }
    var rows = [];
    function row(expr, score) { if (expr) rows.push(expr + ':' + score); }
    row(all(boost, inStock, priced), 7);
    row(all(inStock, priced), 6);
    row(all(boost, inStock), 5);
    row(all(inStock), 4);
    row(all(boost, priced), 3);
    row(all(priced), 2);
    row(all(boost), 1);
    return rows.length ? '_eval([' + rows.join(',') + ']):desc' : '';
  }

  function baseFilters(mode) {
    var f = [];
    var r = C.rules || {};
    if (mode === 'collection' && C.collectionHandle && C.collectionHandle !== 'all') {
      f.push('collection_handles:=' + quote(C.collectionHandle));
    }
    if (mode === 'collection' && (r.excludeCollections || []).length) {
      f.push('collection_handles:!=[' + r.excludeCollections.map(quote).join(',') + ']');
    }
    return f;
  }

  function searchInclude(q) {
    var key = (q || '').trim().toLowerCase().replace(/\s+/g, '');
    var map = (C.rules && C.rules.searchIncludes) || {};
    return map[key] || null;
  }

  function sortExpr(mode, sort, q) {
    var user;
    if (sort === 'relevance' || !sort) {
      user = (q && q !== '*') ? '_text_match:desc' : (mode === 'search' ? 'price:asc' : 'created_at:desc');
    } else {
      user = sort;
    }
    var tiers = mode === 'collection' ? tierSort() : '';
    var parts = [tiers, user].filter(Boolean);
    // Ties: on a search, products with the same price (hundreds at $0) follow
    // relevance, as the previous app did; on a collection, price.
    if (mode === 'search' && q && q !== '*' && user !== '_text_match:desc') parts.push('_text_match:desc');
    else if (user.indexOf('price') === -1 && parts.length < 3) parts.push('price:asc');
    return parts.join(',');
  }

  // ─── Results page (collection + search) ────────────────────────────────────

  var page = null; // { root, mode, state, data, els }

  function readState(mode) {
    var p = new URLSearchParams(window.location.search);
    var s = { q: mode === 'search' ? (p.get('q') || '') : '', filters: {}, sort: '', view: store('cf_tpt_view') || 'grid', page: 1 };
    C.facets.forEach(function (f) {
      var vals = p.getAll('cf_' + f.key);
      if (vals.length) s.filters[f.key] = vals;
    });
    s.sort = p.get('cf_sort') || C.defaultSort[mode] || 'price:asc';
    return s;
  }

  function writeState() {
    var s = page.state;
    var p = new URLSearchParams(window.location.search);
    Array.from(p.keys()).forEach(function (k) { if (k.indexOf('cf_') === 0) p.delete(k); });
    C.facets.forEach(function (f) {
      (s.filters[f.key] || []).forEach(function (v) { p.append('cf_' + f.key, v); });
    });
    if (s.sort && s.sort !== (C.defaultSort[page.mode] || 'price:asc')) p.set('cf_sort', s.sort);
    if (page.mode === 'search') { if (s.q) p.set('q', s.q); }
    var qs = p.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  }

  function facetByKey(key) {
    for (var i = 0; i < C.facets.length; i++) if (C.facets[i].key === key) return C.facets[i];
    return null;
  }

  function filterClauses(except) {
    var s = page.state;
    var clauses = baseFilters(page.mode);
    activeFacets().forEach(function (f) {
      if (f.key === except) return;
      var vals = s.filters[f.key] || [];
      if (vals.length) clauses.push(f.field + ':=[' + vals.map(quote).join(',') + ']');
    });
    return clauses;
  }

  // A facet may be limited to some collections (`only: ['rolex']`), as the
  // previous app did with Rolex Bezel / Rolex Bracelet. Elsewhere — other
  // collections, the search page — it is neither requested nor shown.
  function activeFacets() {
    return C.facets.filter(function (f) {
      if (!f.only || !f.only.length) return true;
      return page && page.mode === 'collection' && f.only.indexOf(C.collectionHandle) !== -1;
    });
  }

  function facetByParam() {
    return activeFacets().map(function (f) { return f.field; }).join(',');
  }

  function baseQuery(q) {
    return {
      collection: C.collection,
      q: q || '*',
      query_by: SEARCH_FIELDS,
      query_by_weights: SEARCH_WEIGHTS,
      num_typos: 1,
      prioritize_exact_match: true,
      max_facet_values: 500,
      include_fields: 'id,title,handle,price,compare_at_price,image,image2,available,tags,' + C.facets.map(function (f) { return f.field; }).join(','),
    };
  }

  // A normal page: one search for the hits plus, for every facet that has a
  // selection, one more without that selection — so the dropdown keeps offering
  // the other brands with their counts (multi-select).
  function fetchPage(pageNo) {
    var s = page.state;
    var q = page.mode === 'search' ? s.q : '';
    var main = Object.assign(baseQuery(q), {
      per_page: C.perPage,
      page: pageNo,
      facet_by: facetByParam(),
      sort_by: sortExpr(page.mode, s.sort, q),
    });
    var f = filterClauses();
    if (f.length) main.filter_by = f.join(' && ');

    var searches = [main];
    var extra = [];
    activeFacets().forEach(function (fc) {
      if (!(s.filters[fc.key] || []).length) return;
      var alt = Object.assign(baseQuery(q), { per_page: 0, page: 1, facet_by: fc.field });
      var fl = filterClauses(fc.key);
      if (fl.length) alt.filter_by = fl.join(' && ');
      searches.push(alt);
      extra.push(fc.field);
    });

    return multiSearch(searches).then(function (results) {
      var r = results[0];
      if (r.error) throw new Error(r.error);
      var counts = {};
      (r.facet_counts || []).forEach(function (fcnt) { counts[fcnt.field_name] = fcnt.counts || []; });
      extra.forEach(function (field, i) {
        var alt = results[i + 1];
        (alt.facet_counts || []).forEach(function (fcnt) { if (fcnt.field_name === field) counts[field] = fcnt.counts || []; });
      });
      return { found: r.found || 0, hits: (r.hits || []).map(function (h) { return h.document; }), counts: counts, page: pageNo };
    });
  }

  // A search whose query carries an "include" rule: every product carrying one
  // of the rule's tags, then the text matches. The rule exists because the text
  // alone misses those products ("rm7" finds RM72s, not the RM 07s), so the
  // tagged set leads. Both sets are small, so they are merged and faceted here.
  var included = null;
  function fetchIncluded() {
    var s = page.state;
    var tags = searchInclude(s.q);
    if (included && included.q === s.q) return Promise.resolve(included);
    var a = Object.assign(baseQuery(s.q), { per_page: 250, page: 1, sort_by: '_text_match:desc' });
    var b = Object.assign(baseQuery('*'), { per_page: 250, page: 1, filter_by: 'tags:=[' + tags.map(quote).join(',') + ']', sort_by: 'price:asc' });
    var bf = baseFilters('search');
    if (bf.length) { a.filter_by = bf.join(' && '); b.filter_by += ' && ' + bf.join(' && '); }
    return multiSearch([a, b]).then(function (results) {
      var seen = {};
      var docs = [];
      (results[1].hits || []).concat(results[0].hits || []).forEach(function (h) {
        if (seen[h.document.id]) return;
        seen[h.document.id] = true;
        docs.push(h.document);
      });
      included = { q: s.q, docs: docs };
      return included;
    });
  }

  function localPage(pageNo) {
    return fetchIncluded().then(function (set) {
      var s = page.state;
      var docs = set.docs.filter(function (d) {
        return C.facets.every(function (f) {
          var vals = s.filters[f.key] || [];
          return !vals.length || vals.indexOf(String(d[f.field])) !== -1;
        });
      });
      var sort = s.sort;
      if (sort && sort !== 'relevance') {
        var parts = sort.split(':');
        var field = parts[0], dir = parts[1] === 'desc' ? -1 : 1;
        docs = docs.slice().sort(function (x, y) {
          var a = x[field], b = y[field];
          if (typeof a === 'string') return a.localeCompare(b || '', undefined, { numeric: true }) * dir;
          return ((a || 0) - (b || 0)) * dir;
        });
      }
      var counts = {};
      C.facets.forEach(function (f) {
        var tally = {};
        set.docs.forEach(function (d) {
          if (d[f.field] == null) return;
          var ok = C.facets.every(function (g) {
            if (g.key === f.key) return true;
            var vals = s.filters[g.key] || [];
            return !vals.length || vals.indexOf(String(d[g.field])) !== -1;
          });
          if (ok) tally[d[f.field]] = (tally[d[f.field]] || 0) + 1;
        });
        counts[f.field] = Object.keys(tally).map(function (v) { return { value: v, count: tally[v] }; });
      });
      return { found: docs.length, hits: docs.slice((pageNo - 1) * C.perPage, pageNo * C.perPage), counts: counts, page: pageNo };
    });
  }

  function load(pageNo, append) {
    var s = page.state;
    s.page = pageNo;
    page.root.classList.add('cf--loading');
    var req = (page.mode === 'search' && searchInclude(s.q)) ? localPage(pageNo) : fetchPage(pageNo);
    var seq = ++page.seq;
    return req.then(function (data) {
      if (seq !== page.seq) return;
      page.lastBatch = data.hits;
      page.data = append ? Object.assign({}, data, { hits: page.data.hits.concat(data.hits) }) : data;
      render(append);
    }).catch(function (err) {
      if (seq !== page.seq) return;
      if (!licence.ok) return fallback();
      if (window.console) console.warn('CustomFind:', err && err.message);
      page.root.classList.add('cf--error');
    }).then(function () { if (seq === page.seq) page.root.classList.remove('cf--loading'); });
  }

  function apply() {
    included = null;
    writeState();
    // Dropdowns stay open across a selection (multi-select); only the sort
    // popover closes, since picking an option is the end of that interaction.
    var sort = page.root.querySelector('.cf-sort.is-open');
    if (sort) sort.classList.remove('is-open');
    load(1, false);
  }

  // ─── Rendering ─────────────────────────────────────────────────────────────

  function activeCount() {
    var s = page.state, n = 0;
    C.facets.forEach(function (f) { n += (s.filters[f.key] || []).length; });
    return n;
  }

  function sortedCounts(list) {
    return (list || []).slice().sort(function (a, b) {
      return String(a.value).localeCompare(String(b.value), undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function toggleValue(key, value) {
    var s = page.state;
    var vals = (s.filters[key] || []).slice();
    var i = vals.indexOf(value);
    if (i === -1) vals.push(value); else vals.splice(i, 1);
    s.filters[key] = vals;
    apply();
  }

  function renderFacets() {
    var s = page.state, d = page.data;
    var bar = page.els.facets;
    var open = {};
    Array.prototype.forEach.call(bar.querySelectorAll('.cf-facet.is-open'), function (n) { open[n.dataset.key] = true; });
    bar.innerHTML = '';

    activeFacets().forEach(function (f) {
      var counts = sortedCounts(d.counts[f.field]);
      var selected = s.filters[f.key] || [];
      if (!counts.length && !selected.length) return;
      var facet = el('div', 'cf-facet' + (open[f.key] ? ' is-open' : '') + (selected.length ? ' has-filter' : ''));
      facet.dataset.key = f.key;

      var title = el('div', 'cf-facet__title');
      var btn = el('button', 'cf-facet__label');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Filter by ' + f.label);
      btn.textContent = f.label;
      btn.addEventListener('click', function (e) { e.stopPropagation(); toggleFacet(facet); });
      title.appendChild(btn);
      var caret = el('span', 'cf-facet__pm');
      caret.addEventListener('click', function (e) { e.stopPropagation(); toggleFacet(facet); });
      title.appendChild(caret);
      if (selected.length) {
        var clear = el('button', 'cf-facet__clear');
        clear.type = 'button';
        clear.setAttribute('aria-label', 'Clear filters by ' + f.label);
        clear.addEventListener('click', function (e) { e.stopPropagation(); s.filters[f.key] = []; apply(); });
        title.appendChild(clear);
      }
      facet.appendChild(title);

      var body = el('div', 'cf-facet__body');
      var list = el('div', 'cf-facet__values');
      counts.forEach(function (c) {
        var on = selected.indexOf(String(c.value)) !== -1;
        var row = el('button', 'cf-value' + (on ? ' is-selected' : ''));
        row.type = 'button';
        row.innerHTML = '<span class="cf-check"><span class="cf-check__inner"></span></span>' +
          '<span class="cf-value__label">' + esc(c.value) + '</span>' +
          '<span class="cf-value__count">' + c.count + '</span>';
        row.addEventListener('click', function () { toggleValue(f.key, String(c.value)); });
        list.appendChild(row);
      });
      body.appendChild(list);
      facet.appendChild(body);
      bar.appendChild(facet);
    });

    // Selected values as chips, with a "Clear all".
    var refine = page.els.refine;
    refine.innerHTML = '';
    if (activeCount()) {
      var clearAll = el('button', 'cf-clear-all');
      clearAll.type = 'button';
      clearAll.textContent = C.strings.clearAll;
      clearAll.addEventListener('click', function () { s.filters = {}; apply(); });
      refine.appendChild(clearAll);
      C.facets.forEach(function (f) {
        (s.filters[f.key] || []).forEach(function (v) {
          var chip = el('button', 'cf-chip');
          chip.type = 'button';
          chip.innerHTML = '<b>' + esc(v) + '</b><span class="cf-chip__x"></span>';
          chip.addEventListener('click', function () { toggleValue(f.key, v); });
          refine.appendChild(chip);
        });
      });
      refine.hidden = false;
    } else {
      refine.hidden = true;
    }
  }

  function toggleFacet(facet) {
    var was = facet.classList.contains('is-open');
    if (!isMobile()) closePopovers();
    facet.classList.toggle('is-open', !was);
  }

  function closePopovers() {
    if (!page) return;
    Array.prototype.forEach.call(page.root.querySelectorAll('.cf-facet.is-open'), function (n) { if (!isMobile()) n.classList.remove('is-open'); });
    var sort = page.root.querySelector('.cf-sort.is-open');
    if (sort) sort.classList.remove('is-open');
  }

  function renderToolbar() {
    var s = page.state, d = page.data;
    var t = page.els.toolbar;
    t.innerHTML = '';

    var views = el('div', 'cf-views');
    [['grid', C.strings.gridView], ['list', C.strings.listView]].forEach(function (v) {
      var b = el('button', 'cf-view cf-view--' + v[0] + (s.view === v[0] ? ' is-active' : ''));
      b.type = 'button';
      b.setAttribute('aria-label', v[1]);
      b.innerHTML = v[0] === 'grid'
        ? '<svg viewBox="0 0 18 18" width="18" height="18" aria-hidden="true"><g fill="currentColor"><circle cx="2" cy="2" r="1.6"/><circle cx="9" cy="2" r="1.6"/><circle cx="16" cy="2" r="1.6"/><circle cx="2" cy="9" r="1.6"/><circle cx="9" cy="9" r="1.6"/><circle cx="16" cy="9" r="1.6"/><circle cx="2" cy="16" r="1.6"/><circle cx="9" cy="16" r="1.6"/><circle cx="16" cy="16" r="1.6"/></g></svg>'
        : '<svg viewBox="0 0 18 18" width="18" height="18" aria-hidden="true"><g fill="currentColor"><circle cx="2" cy="3" r="1.6"/><rect x="6" y="2" width="12" height="2" rx="1"/><circle cx="2" cy="9" r="1.6"/><rect x="6" y="8" width="12" height="2" rx="1"/><circle cx="2" cy="15" r="1.6"/><rect x="6" y="14" width="12" height="2" rx="1"/></g></svg>';
      b.addEventListener('click', function () { s.view = v[0]; store('cf_tpt_view', v[0]); renderToolbar(); renderGrid(false); });
      views.appendChild(b);
    });
    t.appendChild(views);

    var summary = el('span', 'cf-summary', '<b>' + d.found + '</b> ' + C.strings.products);
    t.appendChild(summary);

    var sort = el('div', 'cf-sort');
    var current = C.sort.filter(function (o) { return o.value === s.sort; })[0] || C.sort[0];
    var trigger = el('button', 'cf-sort__value');
    trigger.type = 'button';
    trigger.textContent = isMobile() ? C.strings.sort : current.label;
    trigger.addEventListener('click', function (e) { e.stopPropagation(); var was = sort.classList.contains('is-open'); closePopovers(); sort.classList.toggle('is-open', !was); });
    sort.appendChild(trigger);
    var list = el('div', 'cf-sort__list');
    C.sort.forEach(function (o) {
      var b = el('button', 'cf-sort__btn' + (o.value === s.sort ? ' is-selected' : ''));
      b.type = 'button';
      b.textContent = o.label;
      b.addEventListener('click', function () { s.sort = o.value; apply(); });
      list.appendChild(b);
    });
    sort.appendChild(list);
    t.appendChild(sort);
  }

  function card(doc, view) {
    var ratio = page.ratio === 'square' ? 100 : (page.ratio === 'adapt' ? 100 : 125);
    var media = '';
    if (doc.image) {
      media = '<div class="card__media"><div class="media media--transparent media--hover-effect">' +
        '<img src="' + esc(img(doc.image, 533)) + '" srcset="' + esc(img(doc.image, 360)) + ' 360w, ' + esc(img(doc.image, 533)) + ' 533w, ' + esc(img(doc.image, 720)) + ' 720w" sizes="(min-width: 990px) 25vw, 50vw" alt="' + esc(doc.title) + '" class="motion-reduce" loading="lazy" width="533" height="' + Math.round(533 * ratio / 100) + '">' +
        (doc.image2 && page.secondary ? '<img src="' + esc(img(doc.image2, 533)) + '" alt="" class="motion-reduce" loading="lazy" width="533" height="' + Math.round(533 * ratio / 100) + '">' : '') +
        '</div></div>';
    }
    var url = productUrl(doc.handle);
    // Dawn's own card markup, class for class, so the theme's card CSS styles it
    // exactly as it styled the previous app's cards.
    var price = '<div class="card-information"><span class="caption-large light"></span>' +
      '<div class="price"><div class="price__container"><div class="price__regular">' +
      '<span class="price-item price-item--regular">' + esc(priceText(doc.price)) + '</span></div></div></div></div>';
    var title = '<h3 class="card__heading h5"><a href="' + esc(url) + '" class="full-unstyled-link">' + esc(doc.title) + '</a></h3>' + price;
    return '<li class="grid__item cf-item">' +
      '<div class="card-wrapper product-card-wrapper underline-links-hover"><div class="card card--standard card--media" style="--ratio-percent: ' + ratio + '%;">' +
      '<div class="card__inner ratio color-accent-1" style="--ratio-percent: ' + ratio + '%;">' + media +
      '<div class="card__content"><div class="card__information"><h3 class="card__heading"><a href="' + esc(url) + '" class="full-unstyled-link">' + esc(doc.title) + '</a></h3></div></div></div>' +
      '<div class="card__content"><div class="card__information">' + title + '</div></div>' +
      '</div></div></li>';
  }

  function renderGrid(append) {
    var s = page.state, d = page.data;
    var grid = page.els.grid;
    grid.className = 'cf-results ' + (s.view === 'list' ? 'cf-list' : 'cf-grid grid product-grid grid--2-col-tablet-down grid--' + page.columns + '-col-desktop');
    var hits = append ? (page.lastBatch || []) : d.hits;
    var html = hits.map(function (doc) { return card(doc, s.view); }).join('');
    if (append) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html;

    var empty = page.els.empty;
    if (!d.hits.length) {
      empty.innerHTML = page.mode === 'search' && s.q ? fmt(C.strings.noResults, esc(s.q)) : C.strings.noResultsEmpty;
      empty.hidden = false;
    } else {
      empty.hidden = true;
    }

    var foot = page.els.footer;
    var shown = d.hits.length;
    page.hasMore = shown < d.found;
    foot.querySelector('.cf-viewed').textContent = fmt(C.strings.viewed, shown, d.found);
    foot.querySelector('.cf-load-more').hidden = !page.hasMore || page.autoLoad;
    foot.hidden = !d.hits.length;
  }

  function render(append) {
    renderFacets();
    renderToolbar();
    renderGrid(append);
    page.root.classList.remove('cf--skeleton', 'cf--error');
  }

  function buildShell(root) {
    root.innerHTML =
      '<div class="cf-facets cf-zone">' +
      '  <button type="button" class="cf-mobile-filters"><span class="cf-mobile-filters__icon"></span>' + esc(C.strings.filters) + '</button>' +
      '  <div class="cf-facets__body"></div>' +
      '  <div class="cf-refine" hidden></div>' +
      '</div>' +
      '<div class="cf-sr">' +
      '  <div class="cf-toolbar"></div>' +
      '  <div class="cf-empty" hidden></div>' +
      '  <ul class="cf-results cf-grid grid product-grid"></ul>' +
      '  <div class="cf-footer" hidden><p class="cf-viewed"></p><button type="button" class="cf-load-more"><span>' + esc(C.strings.loadMore) + '</span></button></div>' +
      '</div>';
    return {
      facets: root.querySelector('.cf-facets__body'),
      refine: root.querySelector('.cf-refine'),
      toolbar: root.querySelector('.cf-toolbar'),
      empty: root.querySelector('.cf-empty'),
      grid: root.querySelector('.cf-results'),
      footer: root.querySelector('.cf-footer'),
    };
  }

  function mount(root) {
    var mode = root.dataset.cfMode === 'search' ? 'search' : 'collection';
    page = {
      root: root, mode: mode, seq: 0,
      state: readState(mode),
      data: { found: 0, hits: [], counts: {} },
      columns: Number(root.dataset.cfColumns) || 4,
      ratio: root.dataset.cfRatio || 'portrait',
      secondary: root.dataset.cfSecondary !== 'false',
      els: null,
    };
    root.classList.add('cf', 'cf--skeleton', isMobile() ? 'cf--mobile' : 'cf--desktop');
    page.els = buildShell(root);

    function nearEnd() {
      var r = page.els.footer.getBoundingClientRect();
      return r.top < window.innerHeight + 800;
    }
    function loadMore() {
      if (page.loadingMore || !page.hasMore) return;
      page.loadingMore = true;
      load(page.state.page + 1, true).then(function () {
        page.loadingMore = false;
        // A shopper parked at the very end keeps getting pages until the list
        // has grown past the viewport again.
        if (page.autoLoad && page.hasMore && nearEnd()) loadMore();
      });
    }
    page.els.footer.querySelector('.cf-load-more').addEventListener('click', loadMore);
    // Infinite scroll: the next page arrives as the shopper nears the end of
    // the list, so the button is only a fallback for very old browsers.
    if ('IntersectionObserver' in window) {
      page.autoLoad = true;
      new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) loadMore();
      }, { rootMargin: '800px 0px' }).observe(page.els.footer);
    }
    root.querySelector('.cf-mobile-filters').addEventListener('click', function () { root.classList.toggle('cf--filters-open'); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target) || !e.target.closest('.cf-facet, .cf-sort')) closePopovers(); });
    window.addEventListener('resize', debounce(function () {
      root.classList.toggle('cf--mobile', isMobile());
      root.classList.toggle('cf--desktop', !isMobile());
      if (page.data) renderToolbar();
    }, 150));
    window.addEventListener('popstate', function () { page.state = readState(mode); included = null; load(1, false); });

    // The search page keeps the theme's own search box in sync with ours.
    if (mode === 'search') {
      var box = document.querySelector('.template-search__search input[name="q"], #Search-In-Template');
      if (box) box.value = page.state.q;
    }
    load(1, false);
  }

  // ─── Instant search ────────────────────────────────────────────────────────

  var RECENT = 'cf_tpt_recent';

  function rememberSearch(q) {
    q = (q || '').trim();
    if (!q) return;
    var list = (store(RECENT) || []).filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    store(RECENT, list.slice(0, C.instant.recent || 5));
  }

  function suggestions(q) {
    var p = new URLSearchParams({ q: q, 'resources[type]': 'query', 'resources[limit]': String(C.instant.suggestions || 6) });
    return fetch('/search/suggest.json?' + p.toString(), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return (j && j.resources && j.resources.results && j.resources.results.queries) || []; })
      .catch(function () { return []; });
  }

  function instantProducts(q) {
    var s = Object.assign(baseQuery(q), { per_page: C.instant.products || 6, page: 1, sort_by: '_text_match:desc', highlight_fields: 'title', highlight_start_tag: '<b>', highlight_end_tag: '</b>' });
    var bf = baseFilters('search');
    if (bf.length) s.filter_by = bf.join(' && ');
    var tags = searchInclude(q);
    var searches = [s];
    if (tags) searches.push(Object.assign(baseQuery('*'), { per_page: C.instant.products || 6, page: 1, filter_by: 'tags:=[' + tags.map(quote).join(',') + ']', sort_by: 'price:asc' }));
    return multiSearch(searches).then(function (results) {
      var out = [], seen = {};
      // Tagged (rule) products first, text matches after — same as the results page.
      results.slice().reverse().forEach(function (r) {
        (r.hits || []).forEach(function (h) {
          if (seen[h.document.id]) return;
          seen[h.document.id] = true;
          var hl = (h.highlight && h.highlight.title && h.highlight.title.snippet) || null;
          out.push({ doc: h.document, title: hl || esc(h.document.title) });
        });
      });
      return { items: out.slice(0, C.instant.products || 6), found: results[0].found || 0 };
    });
  }

  function popularProducts() {
    var s = Object.assign(baseQuery('*'), { per_page: C.instant.popular || 6, page: 1, sort_by: tierSort() + ',created_at:desc' });
    return multiSearch([s]).then(function (results) {
      return { items: (results[0].hits || []).map(function (h) { return { doc: h.document, title: esc(h.document.title) }; }), found: 0 };
    });
  }

  function productRow(item) {
    var d = item.doc;
    return '<a class="cf-is__product" href="' + esc(productUrl(d.handle)) + '">' +
      '<span class="cf-is__img">' + (d.image ? '<img src="' + esc(img(d.image, 120)) + '" alt="" loading="lazy" width="60" height="60">' : '') + '</span>' +
      '<span class="cf-is__info"><span class="cf-is__title">' + item.title + '</span><span class="cf-is__price">' + esc(priceText(d.price)) + '</span></span></a>';
  }

  function attachInstant(input) {
    if (input.dataset.cfBound) return;
    input.dataset.cfBound = '1';
    input.setAttribute('autocomplete', 'off');
    var form = input.closest('form');
    var holder = input.closest('.search-modal__content') || form.parentNode;
    var panel = el('div', 'cf-is');
    panel.hidden = true;
    holder.appendChild(panel);
    document.documentElement.classList.add('cf-instant-on');

    var seq = 0;
    function show(html) { panel.innerHTML = html; panel.hidden = false; }
    function hide() { panel.hidden = true; }

    function renderEmptyState() {
      var recent = store(RECENT) || [];
      Promise.resolve(recent.length || C.instant.popular ? popularProducts() : { items: [] }).then(function (pop) {
        var left = '';
        if (pop.items.length) left = '<div class="cf-is__col cf-is__col--products"><h4 class="cf-is__h">' + esc(C.strings.popularProducts) + '</h4><div class="cf-is__products">' + pop.items.map(productRow).join('') + '</div></div>';
        var right = '';
        if (recent.length) right = '<div class="cf-is__col cf-is__col--side"><h4 class="cf-is__h">' + esc(C.strings.latestSearches) + '</h4>' + recent.map(function (r) { return '<a class="cf-is__sugg cf-is__sugg--recent" href="' + esc(C.searchUrl + '?q=' + encodeURIComponent(r)) + '"><span>' + esc(r) + '</span></a>'; }).join('') + '</div>';
        if (!left && !right) return hide();
        show('<div class="cf-is__body">' + left + right + '</div>');
      }).catch(function () { hide(); });
    }

    var run = debounce(function () {
      var q = input.value.trim();
      var mine = ++seq;
      if (!licence.ok) return hide();
      if (q.length < (C.instant.minChars || 1)) return renderEmptyState();
      Promise.all([instantProducts(q), suggestions(q)]).then(function (res) {
        if (mine !== seq || input.value.trim() !== q) return;
        var products = res[0], sugg = res[1];
        if (!products.items.length && !sugg.length) {
          return show('<div class="cf-is__body"><div class="cf-is__none">' + fmt(C.strings.noMatches, esc(q)) + '</div></div>');
        }
        var left = products.items.length
          ? '<div class="cf-is__col cf-is__col--products"><h4 class="cf-is__h">' + esc(C.strings.productMatches) + '</h4><div class="cf-is__products">' + products.items.map(productRow).join('') + '</div></div>' : '';
        var right = sugg.length
          ? '<div class="cf-is__col cf-is__col--side"><h4 class="cf-is__h">' + esc(C.strings.suggestions) + '</h4>' + sugg.map(function (s) {
              var t = s.text || s.styled_text || '';
              return '<a class="cf-is__sugg" href="' + esc(s.url || (C.searchUrl + '?q=' + encodeURIComponent(t))) + '"><span>' + esc(t).replace(new RegExp('(' + esc(q).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'i'), '<b>$1</b>') + '</span></a>';
            }).join('') + '</div>' : '';
        var all = '<a class="cf-is__all" href="' + esc(C.searchUrl + '?q=' + encodeURIComponent(q)) + '">' + fmt(C.strings.viewAllFor, esc(q)) + '</a>';
        show('<div class="cf-is__body">' + left + right + '</div>' + all);
      }).catch(function () {
        if (!licence.ok) { hide(); document.documentElement.classList.remove('cf-instant-on'); }
      });
    }, 150);

    input.addEventListener('input', run);
    input.addEventListener('focus', run);
    if (form) form.addEventListener('submit', function () { rememberSearch(input.value); });
    document.addEventListener('click', function (e) { if (!holder.contains(e.target)) hide(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  }

  function scanInputs() {
    Array.prototype.forEach.call(document.querySelectorAll('.search-modal input[name="q"], .header__search input[name="q"]'), attachInstant);
  }

  // ─── Boot ──────────────────────────────────────────────────────────────────

  function boot() {
    var root = document.getElementById('cf-tpt');
    if (root) mount(root);
    scanInputs();
    if (window.MutationObserver) new MutationObserver(debounce(scanInputs, 250)).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
